<template>
  <b-col class="pr-0 mh-100" md="3">
    <div v-bar class="bar-out">
      <div infinite-wrapper>
        <b-list-group class="list-group-anim bg-white">
          <b-list-group-item
            v-for="customer in list"
            :key="customer.id"
            :to="{ name: 'customerView', params: { id: customer.id } }"
            :class="{ inactive: !customer.active }"
            class="flex-column align-items-start"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="font-weight-bolder m-0">
                {{ customer.name }}
              </h5>
              <template v-if="customer.customerGroup">
                <small class="badge">{{ customer.customerGroup }}</small>
              </template>
            </div>
            <div class="mb-1">
              {{ customer.street }} {{ customer.streetNumber }},
              {{ customer.postCode }} {{ customer.city }}
            </div>
            <div class="d-flex justify-content-between fs-sm">
              <div v-if="customer.regNumber">IČO: {{ customer.regNumber }}</div>
              <div v-if="customer.email">
                <b-icon class="mr-1" icon="envelope" />
                {{ customer.email }}
              </div>
            </div>
            <div class="d-flex justify-content-between fs-sm">
              <div v-if="customer.taxNumber">DIČ: {{ customer.taxNumber }}</div>
              <div v-if="customer.phone">
                <b-icon class="mr-1" icon="telephone-inbound" />
                {{ customer.phone }}
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
        <infinite-loading
          ref="infiniteLoading"
          force-use-infinite-wrapper="true"
          spinner="spiral"
          @infinite="infiniteHandler"
        >
          <template #spinner>
            <b-overlay :blur="null" class="my-4" opacity="0" show />
          </template>
          <div slot="no-results" class="nodata-container">
            <div class="text-center my-3">
              <div class="mb-3">
                <b-icon font-scale="5" icon="question-diamond" />
              </div>
              <h2 class="mb-3">Žiadne dáta</h2>
            </div>
          </div>
          <div slot="no-more" />
        </infinite-loading>
      </div>
    </div>
  </b-col>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    InfiniteLoading,
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    infiniteHandler($state) {
      this.$emit('loaded', true, $state)
    },
    reset() {
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
    },
  },
}
</script>
